import React, { useEffect, useState } from "react";
import { Play, Square, Minus, Plus } from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { click } from "@/lib/click";

export function useClickBeat() {
  const [b, setB] = useState(-2);
  useEffect(() => click.on(setB), []);
  return b;
}

export default function ClickTrack({ bpm, setBpm, compact }) {
  const beat = useClickBeat();
  const [vol, setVol] = useState(0.6);
  const playing = beat !== -2 && click.playing;
  useEffect(() => { if (click.playing) click.setBpm(bpm); }, [bpm]);
  useEffect(() => () => click.stop(), []);
  return (
    <div className={`flex items-center gap-3 rounded-xl border border-white/10 bg-[#111215] ${compact ? "px-3 py-2" : "p-4"}`} data-testid="click-track">
      <button onClick={() => (click.playing ? click.stop() : click.start(bpm))} data-testid="click-toggle" className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${playing ? "bg-amber-400 text-black" : "bg-white/5 text-amber-400 hover:bg-white/10"}`}>
        {playing ? <Square className="w-4 h-4 fill-current" /> : <Play className="w-4 h-4 fill-current ml-0.5" />}
      </button>
      <div className="flex gap-1.5">{[0, 1, 2, 3].map((i) => <div key={i} className={`w-3 h-3 rounded-full transition-colors duration-75 ${playing && beat === i ? (i === 0 ? "bg-amber-400 shadow-[0_0_12px_#fbbf24]" : "bg-sky-400") : "bg-white/10"}`} />)}</div>
      <div className="flex items-center gap-1">
        <button onClick={() => setBpm(Math.max(30, bpm - 1))} className="w-6 h-6 rounded bg-white/5 hover:bg-white/10 flex items-center justify-center"><Minus className="w-3 h-3" /></button>
        <div className="font-mono text-xl text-white w-14 text-center" data-testid="click-bpm">{bpm}</div>
        <button onClick={() => setBpm(Math.min(260, bpm + 1))} className="w-6 h-6 rounded bg-white/5 hover:bg-white/10 flex items-center justify-center"><Plus className="w-3 h-3" /></button>
        <span className="text-[10px] text-zinc-500 ml-1">BPM</span>
      </div>
      {!compact && <div className="flex items-center gap-2 w-28"><span className="text-[10px] text-zinc-500">VOL</span><Slider min={0} max={1} step={0.01} value={[vol]} onValueChange={([v]) => { setVol(v); click.setVol(v); }} /></div>}
    </div>
  );
}
